(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["birth-chart-guided-entry"] && !Shopify.designMode) return;
  try {
    (function () {
    function guidedChartUrl(value, context) {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return value;
      url.search = '';
      url.hash = '';
      url.searchParams.set('source', 'reading-product');
      context = context || {};
      var article = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/([a-z0-9%_-]+\/[a-z0-9%_-]+)$/i.exec(String(context.blog_article_path || ''));
      var id = /^\d{8,20}$/.test(String(context.blog_article_id || '')) ? String(context.blog_article_id) : '';
      if (article || id) {
        url.searchParams.set('source', 'blog-contextual');
        if (article) url.searchParams.set('article', article[1]);
        if (id) url.searchParams.set('article_id', id);
        ['tool', 'cluster'].forEach(function (key) {
          var entry = String(context['blog_' + key] || '');
          if (/^[a-z0-9_-]{1,64}$/.test(entry)) url.searchParams.set(key, entry);
        });
        if (/^(?:primary|inline|inline-related|final|rail|body|topic-nav)$/.test(context.blog_placement || '')) url.searchParams.set('placement', context.blog_placement);
      }
      return url.pathname + url.search;
    }
    function initialize() {
      var links = document.querySelectorAll('[data-birth-chart-calculator-link]');
      var context = {};
      try { if (window.DeckauraBlogAttribution) context = window.DeckauraBlogAttribution.context(); } catch (_) {}
      for (var index = 0; index < links.length; index++) {
        try { links[index].setAttribute('href', guidedChartUrl(links[index].getAttribute('href'), context)); } catch (_) {}
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
